import Toast from "components/toast";
import api from "services/axiosInstance";
import { UploadService } from "services/upload";
import { IMusicData, ITrackSplit } from "types/musicData";
import { ITrackService } from "types/uploadTrackType";
import { CreateSplitSheet } from "./createSplitSheet";
import { UploadLyrics } from "./uploadLyrics";
import { FindArtisByName } from "services/user/getUser";

export const UploadTrackItemSevice = async (
  data: IMusicData,
  coverArtId: string,
  trackIndex: number = 0,
  isGroup: boolean = false,
  containerId?: string
) => {
  if (isGroup && !containerId) {
    throw new Error("Invalid Container Id");
  }

  let countries: string[] = [];

  if (data.schedule.countries) {
    //convert from {country , continent} to country
    for (let i = 0; i < data?.schedule?.countries?.length; i++) {
      countries.push(data.schedule.countries[i].country);
    }
  }

  const ConvertToIsoString = (date: string) => {
    return new Date(date).toISOString();
  };

  const track = data.trackList[trackIndex];
  const body: ITrackService = {
    title: track.trackDetails?.title || "",
    releaseType: data.releaseType.toLocaleUpperCase(),
    releaseLanguage: data.releaseLanguage,
    label: data.recordLabel,
    primaryGenre: data.primaryGenre,
    secondaryGenres: [data?.secondaryGenre],
    recordingYear: Number(track.trackDetails?.recordingYear) || 2025,
    coverArtId: coverArtId,
    masterTrackId: "",
    isExplicit: track.lyrics?.isExplicit || false,
    isPreOrder: false,
    primaryArtistId: data.primaryArtist.id,
    proposedReleaseDate: ConvertToIsoString(
      `${data?.schedule.proposedReleaseDate}`
    ),
    releaseTime: `${data.schedule.releaseTime}`,
    trackPrice: Number(data.schedule.trackPrice),
    targetStores: data.stores,
    targetCountries: countries,
    isrc: track.isrc,
    tempFeaturedArtists: [], /// do
    featuredPlatformArtists: [] /// and this
  };

  //previewClip
  if (track.previewClip?.endTime && track.previewClip.endTime) {
    body.previewClip = {
      startTime: track.previewClip.startTime,
      endTime: track.previewClip.endTime
    };
  }

  if (track.trackArtists) {
    let platformArtists = [];
    let tempArtists = [];

    for (let i = 0; i < track.trackArtists.length; i++) {
      const artist = track.trackArtists[i];
      if (artist.id && artist.id !== data.primaryArtist.id) {
        platformArtists.push(artist.id);
      } else {
        tempArtists.push({
          ...artist,
          tempArtistName: artist.name,
          appleMusicUrl: artist.appleUrl,
          hasStreamingPresence:
            artist.appleUrl || artist.spotifyUrl || artist.youtubeUrl
              ? true
              : false
        });
      }
    }
    body.featuredPlatformArtists = platformArtists;
    body.tempFeaturedArtists = tempArtists;
  }

  //schedule
  if (data.schedule.preorderDate) {
    body.isPreOrder = true;
    body.preOrderDate = ConvertToIsoString(`${data.schedule.preorderDate}`);
  }

  //if in album
  if (containerId) {
    body.trackNumber = trackIndex + 1;
    body.releaseContainerId = containerId;
  }

  //add contributors
  if (track.contributors && track.contributors.length > 0) {
    const ids: string[] = track.contributors
      .map((contributor) => contributor.id)
      .filter((id): id is string => Boolean(id));

    body.collaboratorIds = [...ids];
    body.collaborators = track.contributors.map((contributor) => ({
      name: contributor.name,
      email: contributor.email || "",
      role: contributor.role,
      spotifyUrl: contributor.spotifyUrl || undefined,
      appleUrl: contributor.appleUrl || undefined,
      youtubeUrl: contributor.youtubeUrl || undefined
    }));
  }

  try {
    const trackId = await UploadService(track.file, "audio", true);
    body.masterTrackId = trackId;
    const { data: songData } = await api.post("/songs", body);

    const songId = songData.data.id;

    //upload lyrics
    if (track.lyrics?.text) {
      UploadLyrics(songId, track);
    }

    //upload splitsheet
    if (track.split) {
      CreateSplitSheet(track.split, songId);
    } else if (track.trackArtists && track.trackArtists?.length > 0) {
      const { name } = track?.trackArtists[0];

      const email = FindArtisByName(name)?.email;

      if (!email) {
        return;
      }

      const split: ITrackSplit[] = [
        { recipientName: name, recipientEmail: email || "", percentage: 100 }
      ];

      CreateSplitSheet(split, songId);
    }
    return songId;
  } catch (error) {
    throw error;
  }
};
